<template>
  <main-header class="justify-content-start">
    <logo class="ms-3" :with-top-link="false" />
    <span class="d-flex text-white ms-3">仲介業者向けシステム</span>
    <div class="ms-auto me-1">
      <faq-button />
    </div>
    <ul class="header-nav me-3">
      <manual-browse-item />
    </ul>
  </main-header>
</template>

<script>
import MainHeader from '@/views/atoms/MainHeader'
import Logo from '@/views/atoms/Logo'
import FaqButton from '@/views/molecules/buttons/FaqButton'
import ManualBrowseItem from '@/views/molecules/browseItems/ManualBrowseItem'

export default {
  name: "GuestHeader",
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  components: {
    MainHeader,
    Logo,
    FaqButton,
    ManualBrowseItem,
  },
}
</script>
